import {
  Box,
  Popper,
  PopperProps,
  Radio,
  Stack,
  Typography,
} from '@mui/material';
import { FieldHookConfig, useField } from 'formik';

import { CloseCircleIcon } from '~assets/icons';
import { AutoCompleteSingleChip } from '~components/atoms/custom';
import { FormLabel } from '~components/atoms/form';
import { useSearchOptions } from '~hooks';
import { BaseFilterOption } from '~types';

type Props = {
  label?: React.ReactNode;
  required?: boolean;
  placeholder?: string;
  path: string;
  queryKey: string[];
  bodyRequest?: object;
} & FieldHookConfig<BaseFilterOption | null>;

export const AutoCompleteSingleField: React.FC<Props> = ({
  label,
  required = false,
  placeholder,

  path,
  queryKey,
  bodyRequest,

  ...props
}) => {
  const [{ name, onBlur, value }, { touched, error }, { setValue }] =
    useField<BaseFilterOption | null>(props);

  const onChange = (
    _: React.SyntheticEvent,
    value: BaseFilterOption | null,
  ) => {
    setValue(value);
  };

  const { options, onSearch } = useSearchOptions({
    path,
    queryKey,
    bodyRequest,
  });

  return (
    <>
      {label && <FormLabel label={label} required={required} />}

      <AutoCompleteSingleChip
        fullWidth
        value={value}
        textFieldProps={{
          placeholder,
          name,
          onBlur,
          error: !!(touched && error),
          helperText: touched && error,
        }}
        options={options}
        onSearching={onSearch}
        onChange={onChange}
        disableCloseOnSelect
        renderOption={(props, option) => {
          return (
            <li
              {...props}
              key={option.id}
              style={{
                height: '100%',
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
              >
                <Typography color="text.dark" variant="body2">
                  {option.name}
                </Typography>
                <Radio checked={value?.id === option.id} value={option.name} />
              </Box>
            </li>
          );
        }}
        clearIcon={
          <Stack marginRight={0.5}>
            <CloseCircleIcon />
          </Stack>
        }
        popupIcon={null}
        PopperComponent={CustomPopperComponent}
      />
    </>
  );
};

export const CustomPopperComponent = (props: PopperProps) => {
  return (
    <Popper
      {...props}
      style={{
        width: '100%',
      }}
    />
  );
};
